import { Link } from 'react-router-dom'

export default function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-3xl font-bold text-secondary-900 mb-2">Privacy Policy</h1>
      <p className="text-sm text-secondary-500 mb-10">Effective Date: July 2025</p>

      <div className="prose prose-secondary max-w-none space-y-8 text-secondary-700 leading-relaxed">
        <p>LinkZon is the data controller under GDPR.</p>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">1. Data Collected</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Name</li>
            <li>Email</li>
            <li>Profile information</li>
            <li>Academic credentials</li>
            <li>Payment data (processed by Stripe)</li>
            <li>Technical usage data (cookies)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">2. Legal Basis</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Contractual necessity</li>
            <li>Legitimate interest</li>
            <li>Legal obligations</li>
            <li>Consent (where applicable)</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">3. Data Retention</h2>
          <p>
            Data is retained while the account is active and as required by Swedish accounting law.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">4. User Rights</h2>
          <p>
            Users may request access, correction, deletion, restriction, and data portability.
          </p>
          <p>
            <span className="font-medium text-secondary-900">Supervisory Authority:</span> Integritetsskyddsmyndigheten (IMY), Sweden.
          </p>
          <p>
            <span className="font-medium text-secondary-900">Contact:</span>{' '}
            <a href="mailto:connect@linkzon.se" className="text-accent-600 hover:text-accent-700">connect@linkzon.se</a>
          </p>
        </section>

        <hr className="my-10 border-secondary-200" />

        <section>
          <h2 className="text-xl font-semibold text-secondary-900 mb-3">Cookie Notice</h2>
          <p>
            LinkZon uses cookies to maintain login sessions, improve functionality, and analyze usage. Users may manage cookie preferences in browser settings.
          </p>
        </section>

        <hr className="my-10 border-secondary-200" />

        <div className="flex items-center gap-6 text-sm">
          <Link to="/terms" className="text-accent-600 hover:text-accent-700 font-medium">Terms of Service</Link>
          <Link to="/about" className="text-accent-600 hover:text-accent-700 font-medium">About</Link>
          <a href="mailto:connect@linkzon.se" className="text-accent-600 hover:text-accent-700 font-medium">Contact: connect@linkzon.se</a>
        </div>
      </div>
    </div>
  )
}
